import { TypedUseSelectorHook, useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';
import { AppDispatch } from './store';
import { RootState } from './types/rootTypes';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useDispatch = () => useReduxDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

// Redux Toolkit recommended names
export const useAppDispatch = useDispatch;
export const useAppSelector = useSelector;
